import { useEffect } from 'react';

export const useFilterOverride = (
  setHasFilterOverride: (value: boolean) => void
) => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      setHasFilterOverride(false);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [setHasFilterOverride]);
};
